import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { DataTablesService } from '../../../../../core';
import { LeadContato } from '../lead-contato';
import { isContatoTipoPrincipal } from '../../../../pessoa/contato';

@Component({
    selector: 'sgt-lead-contato-table',
    templateUrl: './lead-contato-table.component.html',
    styleUrls: ['./lead-contato-table.component.less']
})
export class LeadContatoTableComponent implements OnInit {
    idDataTable = 'tableLeadContatos';
    dataTable: any;

    @Input() entities: LeadContato[];
    @Output() edit = new EventEmitter<number>();
    @Output() delete = new EventEmitter<number>();

    constructor(private dataTablesService: DataTablesService) { }

    ngOnInit() {
        this.showTable();
    }

    private showTable() {
        this.dataTablesService.showTable(`#${this.idDataTable}`, this.dataTable, {
            orderFixed: [[ 1, 'desc' ], [ 2, 'asc' ]],
            order: [[3, 'asc'], [4, 'asc']],
            columnDefs: [
                {visible:  false, targets: [1, 2]}
            ],
            info: false,
            paging: false,
            searching: false
        })
        .then(dataTable => this.dataTable = dataTable);
    }

    refresh() {
        this.dataTable?.draw(false);
    }

    /** Verifica se permite excluir o contato */
    canDelete(entity: LeadContato) {
        if (!entity) {
            return false;
        }

        // Não permite excluir o contato principal
        if (isContatoTipoPrincipal(entity.tipo)) {
            return false;
        }

        return true;
    }
}
